/**
 * The redesign accent (indigo). This is the single place it is defined —
 * `theme.palette.primary` is built from it, so a page can read either. Consume
 * one of the two rather than re-typing the hex.
 */
export const ACCENT = '#6A63E0';
export const ACCENT_HOVER = '#5A53D0';
